import SpGuideBox from './guideBox'
import SpComponent from './SpComponent'
import SpTableGrid from './tableGrid'
import SpImageSelect from './imageSelect'
import SpVideoSelect from './videoSelect'
import { SpExportDialogPlugin } from './exportDialog'
import { SpGroupChatPicker, SpGroupChatPickerPlugin } from './groupChatPicker'
import { SpChannelCodePicker, SpChannelCodePickerPlugin } from './channelCodePicker'
import { SpExportListPlugin } from './exportList/plugin'
import { SpBatchLabelPlugin } from './batchLabel/plugin'
import { SpRulesPlugin } from './rulesDialog/plugin'
import SpGlobalHeader from './globalHeader'
import SpQwAuth from './qwAuth'
import SpShopAdminIframe from './shopAdminIframe'
import SpShopMenu from './shopMenu'
import SpRefreshStore from './refreshStore'
import SpGlobalFooter from './globalFooter'
import SpCardContent from './cardContent'
import SpGlobalAlertWarning from './GlobalAlertWarning'
import SpWelcome from './welcome'
import SpIphone from './iphone'
import SpOnlyPicSelect from './onlyPicSelect'
import SpBulkImport from './bulkImport'
import SpExportList from './exportList'
import SpQwContacts from './qwContacts'
import SpSetRole from './setRole'
import SpGuideSelect from './guideSelect'
import SpStoreSelect from './storeSelect'
import SpCommunitySelect from './communitySelect'
import SpLabelList from './labelList'
import SpEditLabel from './editLabel'
import SpBatchLabel from './batchLabel'
import SpGoodsSelect from './goodsSelect'
import SpRulesDialog from './rulesDialog'
import SpRulesGoodsSelect from './rulesGoodsSelect'
import SpAttachment from './attachment'
import SpNotice from './notice'
import SpEditGroup from './editGroup'
import SpGroupsSelect from './groupsSelect'
import SpDepartmentSelect from './departmentSelect'
import SpSearchStore from './searchStore'
import SpSearchGroup from './searchGroup'
import SpSalesOrganization from './salesOrganization'
import SpChooseSalespersonType from './chooseSalespersonType'

export const components = {
  SpTableGrid,
  SpImageSelect,
  SpVideoSelect,
  SpGuideBox,
  SpGroupChatPicker,
  SpChannelCodePicker,
  SpGlobalHeader,
  SpQwAuth,
  SpShopAdminIframe,
  SpShopMenu,
  SpRefreshStore,
  SpGlobalFooter,
  SpCardContent,
  SpGlobalAlertWarning,
  SpWelcome,
  SpIphone,
  SpOnlyPicSelect,
  SpBulkImport,
  SpExportList,
  SpQwContacts,
  SpSetRole,
  SpGuideSelect,
  SpStoreSelect,
  SpComponent,
  SpCommunitySelect,
  SpLabelList,
  SpEditLabel,
  SpBatchLabel,
  SpGoodsSelect,
  SpRulesDialog,
  SpRulesGoodsSelect,
  SpAttachment,
  SpNotice,
  SpEditGroup,
  SpGroupsSelect,
  SpDepartmentSelect,
  SpSearchStore,
  SpSearchGroup,
  SpSalesOrganization,
  SpChooseSalespersonType
}

const plugins = {
  SpExportDialogPlugin,
  SpGroupChatPickerPlugin,
  SpChannelCodePickerPlugin,
  SpExportListPlugin,
  SpBatchLabelPlugin,
  SpRulesPlugin
}

export default {
  install (Vue) {
    Object.keys(components).forEach((name) => {
      const comp = components[name]
      if (!comp.name) {
        throw new Error('component name required: ', comp)
      }
      Vue.component(comp.name, comp)
    })

    Object.keys(plugins).forEach((name) => {
      const plugin = plugins[name]
      Vue.use(plugin)
    })
  },
  ...components
}
